import {
  CheckboxSelectField,
  Field,
  FieldEntry,
  FormFieldType,
  SelectableFieldValue,
  TextareaFieldValue,
} from 'scripts/type'
import getFieldIsRequired from './getFieldIsRequired'

export default function findErrorCodes(displayFields: Field[], values: FieldEntry[]) {
  return displayFields
    .filter((field) => {
      const fieldInValuesIndex = values.findIndex((value) => value.code === field.code)
      const required = getFieldIsRequired(field)
      if (required) {
        const value = values[fieldInValuesIndex]
        const notInput = fieldInValuesIndex === -1
        if (notInput) {
          return true
        }
        const isTextFieldEmpty =
          (field.type === FormFieldType.TextArea && !(value.value as TextareaFieldValue)?.text?.trim()) ||
          (field.type === FormFieldType.TextField && !(value.value as string)?.trim())
        if (isTextFieldEmpty) {
          return true
        }

        if ((field.type as FormFieldType) === FormFieldType.RadioButton) {
          // const isOtherChoiceEmpty =
          //   (value.value as SelectableFieldValue)?.value?.[0] === OtherChoiceValue &&
          //   !(value.value as SelectableFieldValue)?.other?.trim()
          const isChoiceEmpty = !(value.value as SelectableFieldValue)?.value?.length
          if (isChoiceEmpty) {
            return true
          }
        }

        if ((field.type as FormFieldType) === FormFieldType.CheckBox) {
          const checkbox = field as CheckboxSelectField
          const minChoices = checkbox.minChoices
          const maxChoices = checkbox.maxChoices
          const checkedSize = (value.value as SelectableFieldValue)?.value?.length ?? 0
          if (minChoices && checkedSize < minChoices) {
            return true
          }
          if (maxChoices && checkedSize > maxChoices) {
            return true
          }
          return checkedSize === 0
        }
      }
      return false
    })
    .map((field) => field.code)
}
